/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
export const APPLICATION_STATUS_CATEGORY = 10;
export const APPLICATION_STATUS_DESCRIPTION = 20;
export const APPLICATION_STATUS_DOCUMENTS = 25;
export const APPLICATION_STATUS_CONTACT = 30;
export const APPLICATION_STATUS_INSURANCE = 40;
export const APPLICATION_STATUS_SUMMARY = 100;

export const DEATH_APPLICATION_STATUS_SET = [
  APPLICATION_STATUS_CATEGORY,
  APPLICATION_STATUS_DESCRIPTION,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_CONTACT,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_SUMMARY,
];

export const applicationStatuses = {
  APPLICATION_STATUS_CATEGORY,
  APPLICATION_STATUS_DESCRIPTION,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_CONTACT,
  APPLICATION_STATUS_INSURANCE,
  APPLICATION_STATUS_SUMMARY,
};
